import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function ValidationField(values) {
  let errors = [];

  values.forEach((item, index) => {
    let errorObj = {};

    const levelError = ValidateField(
      item.level?.value,
      ValidateName?.LEVEL,
      ValidateName?.LEVEL,
      [ValidateName?.REQUIRED],
    );
    if (levelError) errorObj.level = levelError;

    if (item.approvers && item.approvers.length > 0) {
      let approverErrors = [];
      item.approvers.forEach((approver, idx) => {
        const userError = ValidateField(
          approver.user?.value,
          ValidateName?.USERNAME,
          ValidateName?.USERNAME,
          [ValidateName?.REQUIRED],
        );
        if (userError) approverErrors[idx] = { user: userError };
      });

      if (approverErrors.length > 0) {
        errorObj.approvers = approverErrors;
      }
    } else {
      errorObj.approvers = [{ user: `${ValidateName?.USERNAME} is required` }];
    }

    if (Object.keys(errorObj).length > 0) {
      errors[index] = errorObj;
    } else {
      errors[index] = {}; 
    }
  });

  return errors;
}
